import React from 'react';
import { Text, useTranslation } from '../../components/blocks';
import { HelpPopover } from '../../components/constructed';

const ReferenceIdHelpPopover = () => {
    const { t } = useTranslation('createReturnOrderPage');
    return (
        <HelpPopover header={t('referenceId-helpHeader')}>
            <Text tag={'ul'}>
                <li>{t('referenceId-lengthConstraint')}</li>
                <li>{t('referenceId-characterTypeConstraint')}</li>
                <li>{t('referenceId-uniqueConstraint')}</li>
            </Text>
        </HelpPopover>
    );
};

export { ReferenceIdHelpPopover };
